import { render, staticRenderFns } from "./SecurityCodePassForm.vue?vue&type=template&id=15bf5076"
import script from "./SecurityCodePassForm.vue?vue&type=script&lang=js"
export * from "./SecurityCodePassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports